import { css } from 'lit';

export const q1MarkdownStyles = css`

  :host {
    display: block;
  }

  .markdown-body h1,
  .markdown-body h2 {
    border-bottom: none;
  }

`;
